import React from 'react'
import PropTypes from 'prop-types'

const PriceDiscount = ({ points, cash, onlyCash }) => {
  if (!onlyCash) {
    if (points.regularPrice === 0 || points.regularPrice <= points.price) {
      return ''
    }
  }

  return !onlyCash ? (
    points.regularPrice ? (
      <div className='card-price-from col-12 txt-title-3 txt-subtitle txt-font-body color-ui-2 txt-left justify-content-center align-self-center'>
        de <s className='pr-half'>{points.regularPrice}</s>
        pts por
      </div>
    ) : (
      ''
    )
  ) : cash.regularPrice ? (
    <div className='card-price-from col-12 txt-title-3 txt-subtitle txt-font-body color-ui-2 txt-left justify-content-center align-self-center'>
      de R$ <s className='pr-half'>{cash.regularPrice}</s>
      por
    </div>
  ) : (
    ''
  )
}

PriceDiscount.propTypes = {
  points: PropTypes.object,
  cash: PropTypes.object,
  onlyCash: PropTypes.bool
}

export default PriceDiscount



// WEBPACK FOOTER //
// ./src/features/Cart/Item/PriceDiscount/PriceDiscount.js